"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenStakingAccrualFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TokenStakingAccrualFactory = /** @class */ (function (_super) {
    __extends(TokenStakingAccrualFactory, _super);
    function TokenStakingAccrualFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TokenStakingAccrualFactory.prototype.deploy = function (_stakingToken, _earningToken, overrides) {
        return _super.prototype.deploy.call(this, _stakingToken, _earningToken, overrides || {});
    };
    TokenStakingAccrualFactory.prototype.getDeployTransaction = function (_stakingToken, _earningToken, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _stakingToken, _earningToken, overrides || {});
    };
    TokenStakingAccrualFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TokenStakingAccrualFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TokenStakingAccrualFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TokenStakingAccrualFactory;
}(contracts_1.ContractFactory));
exports.TokenStakingAccrualFactory = TokenStakingAccrualFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_earningToken",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Unstaked",
        type: "event",
    },
    {
        inputs: [],
        name: "accrualToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accruedBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accruedIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "claimFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "claimFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getTotalBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "getUserBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "stakedBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakedTotal",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "supplyIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "unstake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
